import { OpenLink } from 'components/search/bex/enums';
import { OpenLinkState } from 'components/search/bex/interfaces';

const initialOpenLinkState: OpenLinkState = {
  openLink: OpenLink.SAME_WINDOW,
};

export { initialOpenLinkState };
